import {
	clearMatrixWhenNoAccessToken,
	commitClientSessionMatrixState,
	refreshNotaryMatrixState,
	resolveActiveAccessTokenForRefresh,
	shouldSkipRefreshExecution,
	type Matrix,
	type RefreshExecutorParams,
} from "./useRolePermissionsRefreshInternals";

export type { Matrix, RefreshExecutorParams };

export async function executeRolePermissionsRefresh(params: RefreshExecutorParams): Promise<void> {
	const { isRefreshingRef, lastRefreshRef, setMatrix, setPermissionContext, setLoading, setError } = params;
	if (shouldSkipRefreshExecution(isRefreshingRef, lastRefreshRef)) {
		return;
	}
	isRefreshingRef.current = true;
	const { activeContext, activeAccessToken } = resolveActiveAccessTokenForRefresh();
	if (!activeAccessToken) {
		clearMatrixWhenNoAccessToken({ setMatrix, setError, setLoading, setPermissionContext });
		isRefreshingRef.current = false;
		return;
	}
	if (activeContext && activeContext !== "notary") {
		commitClientSessionMatrixState(activeContext, activeAccessToken, { setMatrix, setPermissionContext, setLoading });
		isRefreshingRef.current = false;
		return;
	}
	try {
		await refreshNotaryMatrixState({ setMatrix, setPermissionContext, setLoading, setError });
	} finally {
		isRefreshingRef.current = false;
	}
}
